import { useState, useEffect } from 'react';
import { useContentActions } from 'src/context/providers/ContentContext';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Button, Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

function TextEditor({ termsAndConditions }) {
  const [valueKa, setValueKa] = useState('');
  const [valueEn, setValueEn] = useState('');
  const { updateContentItem } = useContentActions();

  useEffect(() => {
    if (termsAndConditions?.length) {
      setValueKa(termsAndConditions[0].nameKa || '');
      setValueEn(termsAndConditions[0].nameEn || '');
    }
  }, [termsAndConditions]);

  const handleUpdate = () => {
    const valuesToUpdate = {
      nameKa: valueKa,
      nameEn: valueEn,
    };
    updateContentItem(termsAndConditions[0]?.id, valuesToUpdate);
  };

  return (
    <Box sx={{ maxWidth: '800px', padding: 2 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          English
        </Typography>
        <ReactQuill theme="snow" value={valueEn} onChange={setValueEn} />
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Georgian
        </Typography>
        <ReactQuill theme="snow" value={valueKa} onChange={setValueKa} />
      </Box>

      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={handleUpdate}
        sx={{
          paddingX: 4,
          paddingY: 1.5,
          borderRadius: '8px',
          textTransform: 'none',
          fontWeight: 'bold',
        }}
      >
        Save Content
      </Button>
    </Box>
  );
}

TextEditor.propTypes = {
  termsAndConditions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      nameKa: PropTypes.string,
      nameEn: PropTypes.string,
    })
  ),
};

export default TextEditor;
